import React from "react";

const ProgressStatus = ({ progressMessage, status }) => (
  <div className={`progress-status progress-status--${status}`}>
    <span>{progressMessage}</span>
  </div>
);

export default ProgressStatus;
